import decode from 'jwt-decode';
import { SET_USER } from './types';
import { UPDATE_USER_ROLE } from './types';
import SingletonTokenUtil from '../../utils/TokenUtil';
import SingletonUserUtil from '../../utils/UserUtil';

export const setUser = (user: any) => {
  return {
    type: SET_USER,
    payload: user,
  };
};

export const loginUser = (user: any) => {
  return (dispatch: any, getStore: any) => {
    let decodedUser: any = decode(user.accessToken);
    decodedUser.token.isAuthenticated = true;
    SingletonTokenUtil.setToken(user.accessToken);
    SingletonUserUtil.setUser(decodedUser.token);

    dispatch({
      type: SET_USER,
      payload: decodedUser.token,
    });
    // user.response.isAuthenticated = true;

    // SingletonTokenUtil.setToken(user.token);
    // SingletonUserUtil.setUser(user.response);

    // dispatch({
    //   type: SET_USER,
    //   payload: user.response
    // });
  };
};

export const updateUserRole = (role: any) => {
  const user = SingletonUserUtil.setCurrentRole(role);
  SingletonUserUtil.setUser(user);

  return {
    type: UPDATE_USER_ROLE,
    payload: role,
  };
};

export const logoutUser = () => {
  return (dispatch: any) => {
    SingletonUserUtil.clearUser();
    SingletonTokenUtil.clearToken();
    dispatch({
      type: SET_USER,
      payload: null,
    });
  };
};
